const devToolsOptions = {
	// options like actionSanitizer, stateSanitizer
};

export default devToolsOptions;